export default __webpack_public_path__ + "svg/powered/ES_Co-fundedbytheEU_RGB_WHITE Outline.svg?32efebcc";